export const calculatePrice = (priceObject: GQL.IPrice) => {
  // typ slevy
  const discountType = priceObject.discountPercent !== null && priceObject.discountPercent > 0
    ? 'discountPercent'
    : 'discount';

  if (priceObject) {
    let priceWithout = priceObject.priceWithout;

    // sleva v částce
    if (discountType === 'discount') {
      priceWithout = (priceObject.recommendedPriceWithout || 0) - (priceObject.discount || 0);
    }

    // sleva v procentech
    if (discountType === 'discountPercent') {
      priceWithout = ((priceObject.recommendedPriceWithout || 0) / 100) * (100 - (priceObject.discountPercent || 0));
    }

    // zaokrouhlení ceny
    return Math.round((priceWithout || 0) * 100) / 100;
  }

  return null;
}


// WEBPACK FOOTER //
// ./src/helpers/Prices/calculatePrice.ts